import { useState, useEffect } from 'react';
import * as userRoles from '../config/userRoles';

export const getPermissions = () => {
    const permissions = (localStorage.getItem('permissions')?.split(',') || []).map(Number);

    return {
        isAdmin: permissions.includes(userRoles.ROLE_ADMINISTRATOR),
        isRLProductGateAdmin: permissions.includes(userRoles.ROLE_RIGHTSLINE_PRODUCT_GATE_ADMIN),
        isRLProductGateUser: permissions.includes(userRoles.ROLE_RIGHTSLINE_PRODUCT_GATE_CONTENT_SALES),
        isRLProductGateEspnPlusUser: permissions.includes(userRoles.ROLE_RIGHTSLINE_PRODUCT_GATE_ESPN_PLUS),
        isRLProductGateEspnPlusReadOnlyUser: permissions.includes(userRoles.ROLE_RIGHTSLINE_PRODUCT_GATE_ESPN_PLUS_READ_ONLY),
        isLegalUser: permissions.includes(userRoles.ROLE_LEGAL_USER),
        isJobTrackerUser: permissions.includes(userRoles.ROLE_JOB_TRACKER),
        isBulkDateMathToolUser: permissions.includes(userRoles.ROLE_BULK_DATE_MATH_TOOL),
        isRLImportTemplateUser: permissions.includes(userRoles.ROLE_RL_IMPORT_TEMPLATE),
        isRightsetsAssociateUser: permissions.includes(userRoles.ROLE_RIGHTSETS_ASSOCIATE_USER),
        isDealVersioningReadOnly: permissions.includes(userRoles.ROLE_DEAL_VERSIONING_READ_ONLY),
    };
};



export function usePermissions() {
    const [perms, setPerms] = useState(getPermissions());

    useEffect(() => {
        const handleStorage = (e) => {
            if (e.key === 'permissions') {
                setPerms(getPermissions());
            }
        };
        window.addEventListener('storage', handleStorage);
        // Also update on mount in case permissions changed before mount
        setPerms(getPermissions());
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    return perms;
}